module.exports = __webpack_public_path__ + "img/meeting_room.c782a419.png";